import { isUndefined } from '../../../utils/isDefined';

const mapOchData = ({ data, ochResponse }) => {
  const { all, assigned, unassigned } = data;

  const mappedAll = all.map(el => {
    const elNumber = el.number.replace('+', '');
    const founded = ochResponse.find(res => res.number === elNumber);

    if (isUndefined(founded)) {
      return el;
    }

    return { ...el, ochOperator: founded.netoper_N };
  });

  const mappedAssigned = assigned.map(el => {
    const elNumber = el.number.replace('+', '');
    const founded = ochResponse.find(res => res.number === elNumber);

    if (isUndefined(founded)) {
      return el;
    }

    return { ...el, ochOperator: founded.netoper_N };
  });

  const mappedUnassigned = unassigned.map(el => {
    const elNumber = el.number.replace('+', '');
    const founded = ochResponse.find(res => res.number === elNumber);

    if (isUndefined(founded)) {
      return el;
    }

    return { ...el, ochOperator: founded.netoper_N };
  });

  return {
    ...data,
    all: mappedAll,
    assigned: mappedAssigned,
    unassigned: mappedUnassigned
  };
};

export default mapOchData;
